var quotesFlag = true,
    instruments,
    spreads,
    spreadsTable = $('#swfx-table-spreads'),
    quotesTable = $('#swfx-table-quotes'),
    comissions,
    comissionsSelect = $('#comissions-list'),
	dataOld,
	metals = [],
	currencies = [],
    url1 = '//freeserv.dukascopy.com/2.0/index.php?path=swfx_widget/getQuotes&jsonp=quotesCallback',                   //аски, биды...
    url2 = '//freeserv.dukascopy.com/2.0/index.php?path=swfx_widget/getSpreads&jsonp=spreadsCallback',         //средние значения для Европы, США, Азии (за день, месяц, квартал)
    url3 = '//freeserv.dukascopy.com/2.0/index.php?path=common/instruments&jsonp=instrumentsCallback',             //соответствие id и имени (title), пипы... Инструменты, словом
	// filterList1 = ['EUR/USD', 'USD/JPY', 'GBP/USD', 'EUR/JPY', 'USD/CAD', 'AUD/USD', 'USD/PLN', 'XAU/USD', 'USD/CNH', 'E_SandP-500', 'E_DAAX', 'E_Brent'],
	url4 = '//freeserv.dukascopy.com/2.0/index.php?path=common/commissions&jsonp=comissionsCallback',
	titlesList = {
		'E_DAAX': 'Germany&nbsp;30&nbsp;Index',
		'E_Brent': 'US&nbsp;Brent&nbsp;Oil',
		'E_SandP-500': 'US&nbsp;500&nbsp;Index',
		'E_D&J-Ind': 'US&nbsp;30&nbsp;Index',
		'E_Light': 'US&nbsp;Crude&nbsp;Oil',
		'E_NQ-100': 'US&nbsp;100&nbsp;Tech Index',
		'E_SWMI': 'Switzerland&nbsp;20&nbsp;Index',
		'CHI.IDX/USD': 'China&nbsp;A50&nbsp;index',
		'COPPER.CMD/USD': 'High&nbsp;Grade&nbsp;Copper',
		'E_H-Kong': 'Hong&nbsp;Kong&nbsp;Index'
	};
	'E_DAAX', 'E_Brent', 'E_SandP-500', 'E_D&J-Ind', 'E_Light', 'E_NQ-100', 'E_SWMI', 'CHI.IDX/USD', 'COPPER.CMD/USD', 'E_H-Kong'
if (!filterList1) {
	var filterList1 = ['EUR/USD', 'USD/JPY', 'GBP/USD', 'EUR/JPY', 'USD/CAD', 'AUD/USD', 'USD/PLN', 'XAU/USD', 'USD/CNH', 'E_SandP-500', 'E_DAAX', 'E_Brent'],
	    noForex = false;
}

//Callbacks must be declared as global (jsonp)
function instrumentsCallback(data) {
	// console.log(data);
	instruments = data['instruments'];
	metals = metals.concat(data.groups.FX_METALS.instruments,
	                       data.groups.CMD_ENERGY.instruments,
	                       data.groups.CMD_METALS.instruments,
	                       data.groups.IDX.instruments,
	                       data.groups.IDX_AMERICA.instruments,
	                       data.groups.IDX_ASIA.instruments,
	                       data.groups.IDX_EUROPE.instruments);		//инструменты, коммиссия для которых будет для металлов
	currencies = currencies.concat(data.groups.FX_CROSSES.instruments,
		                           data.groups.FX_MAJORS.instruments);
	startDataLoading();                            //После загрузки инструментов начинаем загружать данные для отображения и собственно отображать их
	getData(url2);
};
function comissionsCallback(data) {
	data.splice(data.length/3, data.length*2/3);				//Удаляем комиссии для Deposit и Volume. Оставляем только Equity
	data = spreadsCut(data, 10)
	comissions = data;
	var str = '';
	for (var i = 0; i < data.length; i++) {
		var text;
		if(data[i]) {
			if (noForex) {
				text = data[i].metal + ' ' + comissionsSelect.data('volume');
			} else {
				text = data[i].currency + '/' + data[i].metal + ' ' + comissionsSelect.data('volume');
			}
			str += '<option value="' + i + '">' + text + '</option>';
		}
	}
	comissionsSelect.append(str);
	comissionsSelect.trigger('chosen:updated');
	comissionsSelect.on('change', function() {
		comissionChange();
	});
}

function comissionChange() {
	var instrNumb = comissionsSelect.val();
	var newSpreads = JSON.parse(JSON.stringify(spreads));			//Рекурсивное клонирование массива
	var metOrCur;
	if (instrNumb != 'NONE') {
		for (var i = 0; i < newSpreads.length; i++) {
			if(newSpreads[i]) {
				metOrCur = checkMetalOrCur(newSpreads[i].id);
				newSpreads[i].europe[1] = newSpreads[i].europe[1] + 2 * comissions[instrNumb][metOrCur] * dataOld[i].bid/(1000000 * instruments[spreads[i].id].pipValue);
				newSpreads[i].us[1] = newSpreads[i].us[1] + 2 * comissions[instrNumb][metOrCur] * dataOld[i].bid/(1000000 * instruments[spreads[i].id].pipValue);
				newSpreads[i].asia[1] = newSpreads[i].asia[1] + 2 * comissions[instrNumb][metOrCur] * dataOld[i].bid/(1000000 * instruments[spreads[i].id].pipValue);
			}
		}
		newSpreads = spreadsCut(newSpreads, 100);
	}
	spreadsCallback(newSpreads, true)
}
function checkMetalOrCur(id) {
	for (var i = 1; i < currencies.length; i++) {
		if (currencies[i] == id) {
			return 'currency';
		} else if (metals[i] == id) {
			return 'metal';
		}
	}
}
function quotesCallback(data) {
	data = filtering(data);
	data = quotesCut(data);				//значения приходят некрасивые... С лишними нолями
	data = spreadFunc(data);
	if (quotesFlag) {
		dataOld = draw(data);
		quotesFlag = false;
	} else {
		dataOld = compare(data, dataOld);
	}
};

function spreadsCallback(data, filtered) {
	var str = "",
	    id, a;
	if (!filtered) {
		data = filtering(data);                 //отфильтровываем только заказанные инструменты
		data = spreadsCut(data, 100);
		spreads = data.slice();
		getData(url4);
	}
	for (var i = 0; i < data.length; i++) {
		for(a in data[i]) {
			if (a == 'id') {
				id = data[i].id;                //id не всегда совпадают с именем
				str = str + "<tr><td class='hidd name'>" + getTitle(id) + "</td><td class='digits'>" + data[i]['europe'][1] + "</td><td class='digits'>" + data[i]['us'][1] + "</td><td class='digits'>" + data[i]['asia'][1] + "</td></tr>";
			}
		}
	}
	if (filtered) {
		spreadsTable.empty();
	}
	spreadsTable.html(str);

};

function draw(data) {
	var str = "",
	    id, a;
	for (var i = 0; i < data.length; i++) {
		for(a in data[i]) {
			if(a == 'id') {
				id = data[i][a];                //id не всегда совпадают с именем
				str = str + "<tr><td class='name'>" + getTitle(id) + "</td><td class='digits ask-" + i + "'><span>" + data[i]['ask'] + "</span></td><td class='digits bid-" + i + "'><span>" + data[i]['bid'] + "</span></td><td class='digits spread-" + i + "'><span>" + data[i]['spread'] + "</span></td></tr>";
			}
		}
	}
	quotesTable.html(str);
	links(data.length);
	return data;
};

function getTitle(id) {
	if (id in titlesList) {
		return titlesList[id];
	} else {
		if (instruments[id]['title'].length > 10) {
			return instruments[id]['title'].substr(0, instruments[id]['title'].indexOf('/'));
		} else {
			return instruments[id]['title'];
		}
	}
}

var askLinks = [], bidLinks = [], spreadLinks = [];
function links(dataLength) {
	for (var i = 0; i < dataLength; i++) {
		askLinks[i] = $('.ask-' + i);
		bidLinks[i] = $('.bid-' + i);
		spreadLinks[i] = $('.spread-' + i);
	}
};

function spreadFunc(data) {
	var id, a;
	for (var i = 0; i < data.length; i++) {
		for(a in data[i]) {
			if(a == 'id') {
				id = data[i][a];
				data[i]['spread'] = Math.round((data[i]['ask'] - data[i]['bid']) / instruments[id]['pipValue'] * 10) / 10;
			}
		}
	};
	return data;
};

function compare(data, dataOld) {
	var a;
	for (var i = 0; i < data.length; i++) {

		askLinks[i].removeClass('up down');
		bidLinks[i].removeClass('up down');
		spreadLinks[i].removeClass('up down');

		for(a in data[i]) {
			if (a == 'id') {
				if (parseFloat(data[i]['ask']) > parseFloat(dataOld[i]['ask'])) {
					askLinks[i].addClass('up').find('span').text(data[i]['ask']);
					dataOld[i]['ask'] = data[i]['ask'];
				} else if (parseFloat(data[i]['ask']) < parseFloat(dataOld[i]['ask'])) {
					askLinks[i].addClass('down').find('span').text(data[i]['ask']);
					dataOld[i]['ask'] = data[i]['ask'];
				}
				if (parseFloat(data[i]['bid']) > parseFloat(dataOld[i]['bid'])) {
					bidLinks[i].addClass('up').find('span').text(data[i]['bid']);
					dataOld[i]['bid'] = data[i]['bid'];
				} else if (parseFloat(data[i]['bid']) < parseFloat(dataOld[i]['bid'])) {
					bidLinks[i].addClass('down').find('span').text(data[i]['bid']);
					dataOld[i]['bid'] = data[i]['bid'];
				}
				if (parseFloat(data[i]['spread']) > parseFloat(dataOld[i]['spread'])) {
					spreadLinks[i].addClass('up').find('span').text(data[i]['spread']);
					dataOld[i]['spread'] = data[i]['spread'];
				} else if (parseFloat(data[i]['spread']) < parseFloat(dataOld[i]['spread'])) {
					spreadLinks[i].addClass('down').find('span').text(data[i]['spread']);
					dataOld[i]['spread'] = data[i]['spread'];
				}
			}
		}
	};
	return dataOld;
};

function filtering(data) {
	var filtered = [];
	for (var k = 0; k < filterList1.length; k++) {
		for (var i = 0; i < data.length; i++) {
			if (data[i].id == filterList1[k]) {
				filtered[k] = data[i];
				break
			}
		}
	}
	return filtered;
};

function quotesCut(data) {
	var id, precision, a;
	for (var i = 0; i < data.length; i++) {

//		console.log(data[i]['id']); // break;
		for(a in data[i]) {
			if(a == 'id') {
				id = data[i]['id'];
				precision = Math.round(Math.log(instruments[id]['pipValue'])/Math.log(10))*(-1)+1;    //Необходимая точность округления
				data[i]['ask'] = (+data[i]['ask']).toFixed(precision);
				data[i]['bid'] = (+data[i]['bid']).toFixed(precision);
			}
		}
	};
	return data;
};

function spreadsCut(data, accur) {
	var a;
	for (var i = 0; i < data.length; i++) {
		for (a in data[i]) {
			if(a == 'europe') {
				if (data[i][a]) {												//Для спредов без комиссии из url2
					data[i][a][1] = Math.round(+data[i][a][1]*accur)/accur;
					data[i]['us'][1] = Math.round(+data[i]['us'][1]*accur)/accur;
					data[i]['asia'][1] = Math.round(+data[i]['asia'][1]*accur)/accur;
				} else if (data[i].currency) {											//Для комиссий из url4
					data[i]['currency'] = Math.round(+data[i]['currency']*accur)/accur;
					data[i]['metal'] = Math.round(+data[i]['metal']*accur)/accur;
				}
			}
		}
	};
	return data;
}

function getData(url) {
	$.ajax({
		url: url,
		dataType: 'jsonp'
	});
};
var timer;
function startDataLoading() {
	timer = setTimeout(function tick() {
		getData(url1);
		timer = setTimeout(tick, 1000);
	}, 1);
};

$(function() {
	if (quotesTable.length) {
		var running = true;
		getData(url3);

		$('#switcher').click(function() {
			if (running) {
				clearTimeout(timer);
				$(this).addClass('off');
			} else {
				startDataLoading();
				$(this).removeClass('off');
			}
			running = !running;
		});
	}
});